import { Banesco_open_win } from "../../../../../../assets/BANESCO/banesco";
import { HmacSHA256 } from "crypto-js";
import bills from "../../../../../../assets/png/bill.png";
import ButtonGeneric from "../../../../../../components/Buttons/ButtonGeneric";
import PagosController from "../../../../../../controllers/PagosController";
import { useLocation, useNavigate } from "react-router-dom";
import { UseContextApp } from "../../../../../../Global/Context/appContext";
import { useEffect,useState } from "react";
import moment from "moment";
import Modal from "../../../../../../components/Modals/Modal";


function Banesco({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
  bankInfo,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const { pagoBanesco } = PagosController();
  const [fechaNow, setFechaNow] = useState(moment().format("YYYY-MM-DD"));
  // Funcion que llama al servicio del banco para proceder al pago
  const [message, setMessage] = useState("");
  const [modal, setModal] = useState(false);
  const [{ user }] = UseContextApp();

  const openModal = async () => {
    const apikey = "gB4b8Qv9ndgtiklzly+pp8XFzLv0iwF5";
    const cedula = ""; //cedula del pagador
    const monto = data.metodoAPagar; //monto
    const comprobante = "qs905PA"; // campo dinamico
    const idtransaccion = Date.now().toString(); //ID de la transaccion
    const concepto = "Pago de Servicio NetUno"; //Concepto del tramite
    const secret = "+swzCXbYR/beeeWCOQCOGJVrx21Ikq5c";
    const firmar = apikey + cedula + monto + comprobante + idtransaccion;
    const firma = HmacSHA256(firmar, secret).toString();
    const url = "https://botondepago.banescopagos.com";
    
    const result = await pagoBanesco({
      idCuenta: location.state.data.nroCuenta,
      monto: monto,
      idPago: idtransaccion,
    });
 
 
    if (result.Estatus === "0") 
    {
      localStorage.setItem('transaction', idtransaccion);
      localStorage.setItem('monto', monto);
      localStorage.setItem('fecha', fechaNow);
      localStorage.setItem('monto', monto);
      localStorage.setItem('email', user?.datos?.maskEmail);
     Banesco_open_win(
        url,
        cedula,
        monto,
        location.state.data.nroCuenta,
        idtransaccion,
        concepto,
        apikey,
        result.firma,
        1,
        "https://www.netuno.net.ve/banescoQa/redireccionpagobanesco"
      );
    }
    else
    {
     setModal(true);
     setMessage("Hemos presentado inconvenientes de comunicación con el banco. Por favor, intenta nuevamente más tarde.");
    }
  };



  return (
    <>
      <div className="flex lg:pt-[125px] pt-[220px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
        <div className="lg:w-[70%]  ">
          <div className="absolute left-0 top-0 w-full ">
            <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
              <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                <div className="ml-4 mt-4">
                  <h3 className="text-2xl leading-6 font-medium text-gray-900">
                    Pagar
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    Haz clic en continuar para avanzar en el proceso de pago
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
            <div className="grid lg:gap-[20px] h-full justify-center items-center lg:relative lg:top-[10px] ">
              <div>
                <p className="text-[1.2rem] text-center  text-[#798791]">
                Se utiliza un procesador de pagos  externo, al hacer clic en "Continuar"  acepta los términos y condiciones de la  plataforma en la cual continuará el  proceso de pago.
                </p>
                <p className="text-[1.2rem] text-center pt-2 text-[#798791]">
                  NetUno registrará el pago una vez el mismo se haya confirmado por el proveedor externo.
                </p>
              </div>

            </div>
            <div className="w-full mt-5 flex justify-between gap-[50%]">
              <div className="w-full">
                <ButtonGeneric funtion={back} text={"Volver"} />
              </div>
              <div className="w-full">
                <ButtonGeneric funtion={openModal} text={"Continuar"} />
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[30%] relative sha">
          <div
            className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   
                            before:content-[''] 
                            before:absolute 
                            before:w-[45px] 
                            before:h-[45px] 
                            before:rounded-full 
                            before:bg-white 
                            before:bottom-[-20px]
                            before:left-[-20px]
                            after:content-[''] 
                            after:absolute 
                            after:w-[45px] 
                            after:h-[45px] 
                            after:rounded-full 
                            after:bg-white 
                            after:bottom-[-20px]
                            after:right-[-20px] 
            "
          >
            <div
              className={` bg-[url("../public/bgCard.jpg")] bg-right w-[80%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-25%] z-[10] p-[2rem]`}
            >
              <div className="flex w-full justify-center absolute top-0  right-0  ">
                <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
              </div>
              <div className="flex justify-center items-center">
                <div className="w-[90%] object-contain">
                  <img
                    className="w-full object-contain "
                    src={bankInfo?.banco?.logo}
                    alt=""
                  />
                </div>
              </div>
              <div className="h-40% grid gap-[10px]">
                <div className="font-medium text-center">
                  {data.metodoPago.title}{" "}
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium text-center ">
                    {" "}
                    <div className="whitespace-nowrap">
                      Número de cuenta
                    </div>{" "}
                  </div>
                  <div className="text-center"> {deatils.nroCuenta} </div>
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium w-full text-center">Moneda</div>
                  <div className=" w-full text-center">
                    {data?.data?.title}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-end w-full p-5 gap-4">
              <div className="flex justify-between ">
                <div className="text-[#798791] "> {
                  deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                    (
                      <>
                        Saldo a favor
                      </>
                    )
                    :
                    (
                      <>
                        Saldo
                      </>
                    )
                }</div>{" "}
                <div className="font-medium">Bs {deatils?.deudaTotalVEF}</div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
          </div>

          <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
            <div className="w-full p-5 flex justify-between items-center">
              <div>
                <div className="text-[#798791] ">Monto a Pagar</div>
                <div className="text-2xl font-medium">
                  <span className="text-[#798791] pr-2 ">Bs</span>
                  {data?.metodoAPagar}
                </div>
              </div>
              <div className="w-[35px] ">
                <img src={bills} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        message={message}
        active={modal}
        setActive={setModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex  flex-col gap-2 ">
            <button
              type="button"
              onClick={() => setModal(false)}
              className="inline-flex w-full justify-center rounded-md bg-[#09101F] px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto"
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Banesco;
